import styled from 'styled-components';
import { IDropdownStyles } from '@fluentui/react';

export const dropdownStyles: Partial<IDropdownStyles> =
{
    root:
    {
        width: '100%',
    },
    dropdownItem:
    {
        display: 'flex',
        alignItems: 'left',
    },
    title:
    {
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'left',
    },
};

export const Row = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: nowrap;
`;

export const ColDropdown = styled.div`
    flex: 0 0 70%;
    min-width: 0;
`;

export interface ColButtonProps
{
    alignment?: string;
    paddingTop?: string;
}

export const ColButton = styled.div<ColButtonProps>`
    flex: 0 0 30%;
    display: flex;
    justify-content: ${props => props.alignment ?? 'center'};
    padding-top: ${props => props.paddingTop ?? '1.85rem'};
`;